import { render, staticRenderFns } from "./DetalhamentoValoresDeclarados.vue?vue&type=template&id=6053890d&scoped=true"
import script from "./DetalhamentoValoresDeclarados.vue?vue&type=script&lang=js"
export * from "./DetalhamentoValoresDeclarados.vue?vue&type=script&lang=js"
import style0 from "./DetalhamentoValoresDeclarados.vue?vue&type=style&index=0&id=6053890d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6053890d",
  null
  
)

export default component.exports